import React from 'react';
import { CatalogCategorySectionProvider } from '@apps/registry/common/components/Catalog/components/CatalogCategorySectionProvider';
import { ExplodedCategoryProps } from '../../ExplodedCategory';
import { CategoryRecommendationsCarousel } from '../../../CategoryRecommendationsCarousel/CategoryRecommendationsCarousel';
import { BoxProps } from '@withjoy/joykit';

export interface TopCategoryProductsCarouselProps {
  category: ExplodedCategoryProps['subcategories'][number];
  onBrowseCategoryClick: ExplodedCategoryProps['onBrowseCategoryClick'];
  variant?: 'default' | 'spotlight';
  zIndex?: BoxProps['zIndex'];
}

export const TopCategoryProductsCarousel = ({ category, onBrowseCategoryClick, variant = 'default', zIndex }: TopCategoryProductsCarouselProps) => (
  <CatalogCategorySectionProvider
    key={category.id}
    value={category}
  >
    <CategoryRecommendationsCarousel
      onBrowseCategoryClick={() => onBrowseCategoryClick(category, 'categoryRecShowAll', false)}
      category={category}
      variant={variant}
      zIndex={zIndex}
    />
  </CatalogCategorySectionProvider>
);
